import { isNumber } from '@finect/front-utils/isNumber';
import { getTagWithContents, getBanks } from '../../store/content/actions';
import { getStorefronts, fetchTagPages } from '../../store/products/actions';
import { setFundHomeStatus, getFundsMostViewed, getManagementCompaniesWithFilter, getFundsByYTD, getFundsByAssets, getCategories, getManagementCompanies, getCategory, getFundsByCategory, getManagementCompany, getFundsByIdManagementCompany } from '../../store/fund/actions';
export function fetchIICHomeInitialData(_ref) {
  let {
    productType
  } = _ref;
  const pagesTag = productType.id === 'plan' ? 'planes-de-pensiones' : productType.tag;
  return function (dispatch) {
    const familyPromises = [dispatch(getTagWithContents(productType.tag)), dispatch(fetchTagPages(pagesTag)), dispatch(getStorefronts()), dispatch(getBanks(34491)), dispatch(getFundsByYTD(productType, 10)), dispatch(getFundsByAssets(productType, 10)), dispatch(getFundsMostViewed(productType, 1, 10, 'week')), dispatch(getManagementCompaniesWithFilter(productType, 'MS', {
      orderBy: '-stats/assets'
    }, 1, 500)), dispatch(getManagementCompanies(productType)), dispatch(getCategories(productType))];
    const userPromises = [];
    const promises = [...familyPromises, ...userPromises];
    return Promise.all(promises).then(() => dispatch(setFundHomeStatus(productType.id)));
  };
}
export function clearIICHome() {
  return function (dispatch) {
    return Promise.resolve(dispatch(setFundHomeStatus('')));
  };
}
export function fetchIICCategoryInitialData(_ref2) {
  let {
    productType,
    category
  } = _ref2;
  return function (dispatch) {
    const promises = [dispatch(getCategory(productType, category)), ...(isNumber(category) ? [dispatch(getFundsByCategory(productType, category))] : [])];
    return Promise.all(promises);
  };
}
export function fetchIICManagementCompanyInitialData(_ref3) {
  let {
    productType,
    managementCompany
  } = _ref3;
  return function (dispatch, getState) {
    return Promise.resolve(dispatch(getManagementCompany(productType.api, managementCompany))).then(() => {
      const model = getState().fund.managementCompany.model;
      const promises = model ? [dispatch(getFundsByIdManagementCompany(productType, model.id))] : [];
      return Promise.all(promises);
    });
  };
}